<ng-container
  *ngTemplateOutlet="(readonly || !canOrder)? readOnlyTemplate : editTemplate "
>
</ng-container>

<ng-template #editTemplate>
  @if (delivery && product) {
  <div
    class="mb-4"
    [ngClass]="{'line-separator--light-grey pb-4': isLastShipment}"
  >
    <div
      class="purchase-options__address"
      [ngClass]="{'decision-point' : order.isDecisionPoint,
      'list-item': viewType === 'list-item',
      'with-variations': product.hasVariations}"
    >
      <div class="input-outer--container">
        <div class="input-inner--container">
          <div
            class="purchase-options__address--input pt-0"
            [ngClass]="{'list-item': viewType === 'list-item'}"
          >
            <div class="qty--container">
              @if (showInputLabel) {
              <div class="label color--primary-grey">Qty Per Address</div>
              } @if (!product.isCustomizable) {
              <input
                [attr.id]="'quantity-input-' + orderItem.id + '-' + delivery.id"
                (change)="onQuantityChanged($event)"
                (blur)="onQuantityBlur()"
                min="0"
                digitOnly
                type="number"
                [value]="delivery.quantity"
                [disabled]="!canPurchase || delivery.is_uneligible"
              />
              } @if (!delivery.is_uneligible) { @if (product.isCustomizable) {
              <div class="customizations-tooltip mb-2">
                <span class="input-like m-0" (click)="addCustomization()"
                  >{{delivery.quantity}}</span
                >
                <customization-info
                  [customizations]="delivery.customizations"
                ></customization-info>
              </div>
              } }
            </div>
          </div>
          @if (product.hasVariations) {
          <div class="flex-extended desktop-only"></div>
          } @if (product.hasVariations) {
          <div class="size--container">
            @if (showInputLabel) {
            <div class="label color--primary-grey">Variant</div>
            }
            <div
              ngbTooltip="{{ selectedSkusLabel }}"
              placement="bottom"
              tooltipClass="tooltips"
            >
              <ng-select
                class="ng-select--wrapper dropdown-extra-wide-300"
                [items]="variationInfos"
                bindValue="skuId"
                [searchable]="false"
                (change)="updateVariation($event)"
                [clearable]="false"
                [(ngModel)]="delivery.sku_id"
                [disabled]="!canPurchase"
                dropdownPosition="bottom"
              >
                <ng-template ng-label-tmp let-item="item">
                  <div class="font-5 grey font-bold">
                    {{ item.label || delivery.sku_id}}
                  </div>
                  <div class="font-5 grey">
                    @if (!product.isBuyingWindow) {
                    <app-product-order-item-in-stock
                      [product]="product"
                      [sku]="item.sku"
                      fontSize="font-5"
                      orientation="horizontal"
                      viewType="sku-item"
                      [orderItemId]="orderItem.id"
                      class="mb-2"
                    ></app-product-order-item-in-stock>
                    } @if (showMinOrderInBody(item.sku)) {
                    <app-product-order-item-min-max
                      [orderItem]="orderItem"
                      [product]="product"
                      [showQuantityInSeparateLine]="false"
                      [headerPosition]="false"
                      [sku]="item.sku"
                      viewType="detailed"
                      fontSize="font-5"
                    >
                    </app-product-order-item-min-max>
                    }
                  </div>
                </ng-template>
                <ng-template ng-option-tmp let-item="item">
                  @for (label of item.skuLabels; track $index) {
                  <div class="d-block font-5 grey font-bold">{{ label }}</div>
                  }
                  <div class="font-5 grey text-align-start">
                    @if (!product.isBuyingWindow) {
                    <app-product-order-item-in-stock
                      [product]="product"
                      [sku]="item.sku"
                      fontSize="font-5"
                      orientation="horizontal"
                      viewType="sku-item"
                      [orderItemId]="orderItem.id"
                      class="mb-2"
                    ></app-product-order-item-in-stock>
                    } @if (showMinOrderInBody(item.sku)) {
                    <app-product-order-item-min-max
                      [orderItem]="orderItem"
                      [product]="product"
                      [showQuantityInSeparateLine]="false"
                      [headerPosition]="false"
                      [sku]="item.sku"
                      viewType="detailed"
                      fontSize="font-5"
                    >
                    </app-product-order-item-min-max>
                    }
                  </div>
                </ng-template>
              </ng-select>
            </div>
          </div>
          }
        </div>
        <div class="shipment-outer--container">
          <div class="flex-extended desktop-only"></div>
          <div
            class="shipping-address--container"
            [ngClass]="{'list-item': viewType === 'list-item'}"
          >
            @if (showInputLabel) {
            <div class="label color--primary-grey">Ship-To Address</div>
            }
            <app-ship-to-address
              [isInline]="true"
              [order]="order"
              [delivery]="delivery"
              [orderItem]="orderItem"
              (addressSelected)="updateAddressData($event)"
              [disabled]="!canPurchase"
              class="ng-select--wrapper searchable address--selector"
            >
            </app-ship-to-address>
          </div>
          @if (!hideShippingMethod) {
          <div class="flex-extended desktop-only"></div>
          } @if (!hideShippingMethod) {
          <div class="shipping-method--container">
            <ng-container>
              @if (showInputLabel) {
              <div class="label color--primary-grey">
                {{ mobile ? 'Shipping' : 'Shipping Method'}}
              </div>
              } @if (isSingleShippingMethod && !delivery.is_uneligible) {
              <span class="lh-3">{{delivery.method | translate}}</span>
              } @if (!isSingleShippingMethod && !delivery.is_uneligible) {
              <ng-select
                class="ng-select--wrapper"
                [items]="shippingMethods"
                bindValue="label"
                [searchable]="false"
                (change)="updateShippingMethod($event)"
                [clearable]="false"
                [(ngModel)]="delivery.method"
                [disabled]="!canPurchase"
                dropdownPosition="bottom"
              >
                <ng-template ng-label-tmp let-item="item">
                  <span class="font-5 grey">{{ item | translate }}</span>
                </ng-template>
                <ng-template ng-option-tmp let-item="item">
                  <span class="font-5">{{ item | translate }}</span>
                </ng-template>
              </ng-select>
              }
            </ng-container>
            @if (delivery.is_uneligible) {
            <span class="lh-3"
              >Not Eligible &nbsp;
              <button class="btn btn-icon" (click)="showDPFaqDialog()">
                <i class="fas fa-exclamation-circle"></i>
              </button>
            </span>
            }
          </div>
          }
        </div>
      </div>
      @if (product.hasVariations) {
      <div class="align-self-center mt-3">
        <app-product-order-item-price
          [attr.id]="'item-price-' + orderItem.id + '-' + delivery.id"
          [orderItem]="orderItem"
          [sku]="assignedSku"
          fontSize="font-4"
        ></app-product-order-item-price>
      </div>
      } @if (showTotalInline) {
      <div>
        <div
          class="col col-2 px-3 flex-line"
          [ngClass]="{'list-item': viewType === 'list-item'}"
        >
          @if (isLastShipment) {
          <div>
            <strong class="price">{{ totals | currency }}</strong>
            <span>SubTotal</span>
          </div>
          }
        </div>
      </div>
      }
    </div>
    <div>
      @if (!delivery.is_uneligible) { @if (product.isCustomizable) {
      <div class="mt-2">
        <button
          class="btn btn-outline-primary"
          (click)="addCustomization()"
          [disabled]="!canCustomize"
        >
          Customize
        </button>
        @if (!canCustomize && order.isDecisionPoint) {
        <i
          class="fal fa-exclamation-triangle yellow"
          title="This product can be customized but Decision Point Order does not support it. Please use other order."
        ></i>
        }
      </div>
      } }
    </div>
    <div>
      @if (canRemoveAddress) {
      <strong
        [attr.id]="'remove-address-btn-' + orderItem.id + '-' + delivery.id"
        class="purchase-options__address-remove"
        (click)="removeAddress()"
        >Remove
      </strong>
      }
    </div>
  </div>
  }
</ng-template>

<ng-template #readOnlyTemplate>
  @if (delivery.quantity > 0) {
  <div class="order-item--bottom d-flex mt-3">
    <div class="full-width">
      <!-- Header Row -->
      <div class="order-item--shipment-header desktop-only">
        <div class="order-item--qty-col">
          <div class="color--primary-grey">Quantity</div>
        </div>
        @if (product.hasVariations && !isLegacySku) {
        <div class="order-item--size-col">
          <div class="color--primary-grey">Variant</div>
        </div>
        }
        <div class="order-item--address-col">
          <div class="label color--primary-grey">Ship-To Address</div>
        </div>
        @if (orderContainsSap && order.isCustom) {
        <div class="order-item--sap-col">
          <div class="label color--primary-grey">SAP</div>
        </div>
        } @if (showTrackingInfo) {
        <div class="order-item--status-col">
          <div class="label color--primary-grey">Status</div>
        </div>
        } @if (showTrackingInfo) {
        <div class="order-item--tracking-col">
          <div class="label color--primary-grey">
            Tracking
            <button
              class="btn btn-icon"
              title="Refresh tracking status"
              (click)="refreshStatus.emit()"
            >
              <i
                class="fal fa-sync"
                [ngClass]="{'rotate': _refreshingTrackingStatus}"
              ></i>
            </button>
          </div>
        </div>
        } @if (!showTrackingInfo && !(orderContainsSap && order.isCustom) &&
        !hideShippingMethod) {
        <div class="order-item--shipping-method-col">
          <div class="label color--primary-grey">Shipping</div>
        </div>
        } @if (product.hasVariations && !isLegacySku) {
        <div class="order-item--qty-col">
          <div class="label color--primary-grey">Price</div>
        </div>
        }
      </div>
      <!-- Data Row -->
      <div class="order-item--shipment-data">
        <!-- Quantity Column -->
        <div class="order-item--qty-col">
          <div class="mobile-label">
            <div class="color--primary-grey">Quantity</div>
          </div>
          <div class="d-flex flex-column align-items-center">
            <strong>{{ shippingQuantity }}</strong>
            <customization-info
              [customizations]="delivery.customizations"
            ></customization-info>
          </div>
        </div>
        <!-- Size Column -->
        @if (product.hasVariations && !isLegacySku) {
        <div class="order-item--size-col">
          <div class="mobile-label">
            <div class="color--primary-grey">Variant</div>
          </div>
          <div>
            @for (label of selectedSkusLabels; track $index) {
            <div class="d-block fw-bold">{{label}}</div>
            }
          </div>
        </div>
        }
        <!-- Address Column -->
        <div class="order-item--address-col">
          <div class="mobile-label">
            <div class="label color--primary-grey">Ship-To Address</div>
          </div>
          <div>
            <div>
              <strong>{{ getShipToLabel(delivery) }}</strong>
              @if (canEditDeliveryTo) {
              <button
                (click)="editDeliverTo(delivery)"
                title="Edit Attention"
                class="btn btn-icon ms-2"
              >
                <i class="fal fa-edit"></i>
              </button>
              }
            </div>
            <span class="d-block">{{ delivery.street_1 }}</span>
            <span class="d-block">{{ delivery.getCSZ() }}</span>
          </div>
        </div>
        <!-- SAP Column -->
        @if (orderContainsSap && order.isCustom) {
        <div class="order-item--sap-col">
          <div class="mobile-label">
            <div class="label color--primary-grey">SAP</div>
          </div>
          @if (!completed) {
          <div>
            {{getSapInfo(delivery)}} @if (canEditDeliveryTo) {
            <button
              (click)="editSAP(delivery)"
              [disabled]="updatingDeliveryId === delivery.id"
              title="Edit SAP"
              class="btn btn-icon ms-2"
            >
              @if (updatingDeliveryId === delivery.id) {
              <i class="fal fa-sync rotate"></i>
              } @if (updatingDeliveryId !== delivery.id) {
              <i class="fal fa-edit"></i>
              }
            </button>
            }
          </div>
          } @if (completed) {
          <div>
            {{getSapInfo(delivery)}}
            <span class="d-block"
              >Status: {{ orderItem.state | translate }}</span
            >
            @if (delivery.tracking_number) {
            <div>
              <app-tracking-data
                [trackingData]="delivery.tracking_number"
              ></app-tracking-data>
            </div>
            }
          </div>
          }
        </div>
        }
        <!-- Status Column -->
        @if (showTrackingInfo) {
        <div
          [attr.id]="'tracking-status-' + orderItem.id + '-' + delivery.id"
          class="order-item--status-col"
          [ngClass]="{'delivered': isDelivered(status), 'tracking--loader': _refreshingTrackingStatus}"
        >
          <div class="mobile-label">
            <div class="label color--primary-grey">Status</div>
          </div>
          <div>{{status | translate}}</div>
        </div>
        }
        <!-- Tracking Column -->
        @if (showTrackingInfo) {
        <div
          [attr.id]="'tracking-info-' + orderItem.id + '-' + delivery.id"
          class="order-item--tracking-col tracking--link"
          [ngClass]="{'tracking--loader': _refreshingTrackingStatus}"
        >
          <div class="mobile-label">
            <div class="label color--primary-grey">
              Tracking
              <button
                class="btn btn-icon"
                title="Refresh tracking status"
                (click)="refreshStatus.emit()"
              >
                <i
                  class="fal fa-sync"
                  [ngClass]="{'rotate': _refreshingTrackingStatus}"
                ></i>
              </button>
            </div>
          </div>
          <app-delivery-tracking
            [vendor]="orderItem.vendor"
            [orderState]="order.state"
            [delivery]="delivery"
          >
          </app-delivery-tracking>
        </div>
        }
        <!-- Shipping Method Column (when no tracking and no SAP) -->
        @if (!showTrackingInfo && !(orderContainsSap && order.isCustom) &&
        !hideShippingMethod) {
        <div
          class="order-item--shipping-method-col"
          [ngClass]="{'order-item--backordered': !completed, 'order-item--shipping': completed}"
        >
          <div class="mobile-label">
            <div class="label color--primary-grey">Shipping</div>
          </div>
          <div>
            <strong>{{ delivery.method | translate }}</strong>
            @if (completed) {
            <span>Status: {{ orderItem.state | translate }}</span>
            } @if (completed && delivery.tracking_number) {
            <div>
              <app-tracking-data
                [trackingData]="delivery.tracking_number"
              ></app-tracking-data>
            </div>
            }
          </div>
        </div>
        } @if (product.hasVariations && !isLegacySku) {
        <div class="order-item--qty-col">
          <div class="mobile-label">
            <div class="label color--primary-grey">Price</div>
          </div>
          <app-product-order-item-price
            [orderItem]="orderItem"
            [sku]="assignedSku"
            fontSize="font-4"
          ></app-product-order-item-price>
        </div>
        }
      </div>
      <!-- Legacy SKU handling-->
      @if (product.hasVariations && isLegacySku) {
      <div class="legacy-sku-row">
        <div class="font-bold font-5 legacy-sku--label">Variations</div>
        <div class="font-bold font-5 legacy-sku--price">Price Per Unit</div>
        <div class="font-bold font-5 legacy-sku--qty">Quantity</div>
        <div class="font-bold font-5 legacy-sku--total">Total</div>
      </div>
      @for (orderSku of orderItem.skus; track orderSku) {
      <div class="legacy-sku-row">
        <div class="font-5 legacy-sku--label">
          {{getLabelForLegacySku(orderSku.sku_id)}}
        </div>
        <div class="font-5 legacy-sku--price fw-normal">
          <app-product-order-item-price
            [orderItem]="orderItem"
            [sku]="getProductSku(orderSku.sku_id)"
            [hideUOM]="true"
            componentClasses="fw-normal"
            fontSize="font-5"
          ></app-product-order-item-price>
        </div>
        <div class="font-5 legacy-sku--qty">{{orderSku.quantity}}</div>
        <div class="font-5 legacy-sku--total">
          <span class="price fw-normal">{{orderSku.price | currency }}</span>
        </div>
      </div>
      } }
    </div>
  </div>
  }
</ng-template>
